import { BaseEntity } from "yt-ng-framework";

export class VrstaStavkiKodKupca extends BaseEntity{
        constructor(){
            super();
        }

        VrstaStavkiId: number = null;
        KomitentId: number = null;
        SifraKodKomitenta: string = null;

        Deserialize(input: any){
            this.ID=input.ID;
            this.VrstaStavkiId = input.VrstaStavkiId;
            this.KomitentId = input.KomitentId;
            this.SifraKodKomitenta = input.SifraKodKomitenta;
            return this;
        }

        Serialize(input: VrstaStavkiKodKupca){
            return input;
        }
}